export default "__VITE_ASSET__7bf72333__"